import React, { useState } from 'react';
import { Radio, Space, Table, Tag } from 'antd';
import { Badge } from 'antd';
const topOptions = [
  {
    label: 'topLeft',
    value: 'topLeft',
  },
  {
    label: 'topCenter',
    value: 'topCenter',
  },
  {
    label: 'topRight',
    value: 'topRight',
  },
  {
    label: 'none',
    value: 'none',
  },
];
const bottomOptions = [
  {
    label: 'bottomLeft',
    value: 'bottomLeft',
  },
  {
    label: 'bottomCenter',
    value: 'bottomCenter',
  },
  {
    label: 'bottomRight',
    value: 'bottomRight',
  },
  {
    label: 'none',
    value: 'none',
  },
];
const columns = [
  {
    title: 'No.',
    dataIndex: 'number',
    key: 'number',
  },
  {
    title: 'Merchant ID',
    dataIndex: 'merchantID',
    key: 'merchantID',
  },
  {
    title: 'Company Name',
    dataIndex: 'CompanyName',
    key: 'CompanyName',
  },
  {
    title: 'Merchant Status',
    dataIndex: 'status',
    key: 'status',
    render: () => <Badge status={'success'} text="Operating" />,
  },
  {
    title: 'Operation',
    key: 'operation',
    render: (_, record) => (
      <Space size="middle">
        <a>Modify</a>
        <a>Deactivate</a>
      </Space>
    ),
  },
];
const data = [
  {
    key: '1',
    number: 1,
    merchantID: '291465445',
    CompanyName: 'AAA Company',
    status: 'Operating',

  },
  {
    key: '2',
    number: 2,
    merchantID: '291465446',
    CompanyName: 'BBB Super Market',
    status: 'Operating',
  },
  {
    key: '3',
    number: 3,
    merchantID: '291465447',
    CompanyName: 'CCC Telecom',
    status: 'Operating',

  },
];
const MerchantManagementPage = () => {
  const [bottom, setBottom] = useState('bottomRight');
  return (
    <div>
      <Table
        columns={columns}
        pagination={{
          position: [bottom],
        }}
        dataSource={data}
      />
    </div>
  );
};
export default MerchantManagementPage;